import { Box, TextField, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
/**
 * The SerialNumberFilter component
 * @component
 *
 * @param {Object} props
 * @param {string} props.orderDateFrom
 * @param {string} props.orderDateUntil
 * @param {function} props.handleOrderDateFrom
 * @param {function} props.handleOrderDateUntil
 * @returns {JSX.Element}
 */

const OrderDateFilter = ({ handleOrderDateFrom, handleOrderDateUntil }) => {
  const [dateFrom, setDateFrom] = useState('')
  const [dateUntil, setDateUntil] = useState('')

  useEffect(() => {
    if (dateFrom && dateUntil && dateUntil < dateFrom) {
      setDateUntil(dateFrom)
      enqueueSnackbar("'Fecha desde' no puede ser mayor que 'Fecha hasta'", {
        variant: 'error',
        transitionDuration: '5000',
      })
    }
    handleOrderDateFrom(dateFrom)
    handleOrderDateUntil(dateUntil)
  }, [dateFrom, dateUntil])

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
        mt: 2,
      }}
    >
      <Box
        sx={{
          width: '49.5%',
        }}
      >
        <Typography variant="body1">Fecha desde</Typography>
        <TextField
          sx={{ mb: 1 }}
          InputLabelProps={{ shrink: true }}
          InputProps={{ maxLength: 12 }}
          variant="standard"
          value={dateFrom}
          onChange={(e) => {
            setDateFrom(e.target.value)
          }}
          type={'date'}
          fullWidth
        />
      </Box>
      <Box
        sx={{
          width: '49.5%',
        }}
      >
        <Typography variant="body1">Fecha hasta</Typography>
        <TextField
          sx={{ mb: 1 }}
          InputLabelProps={{ shrink: true }}
          InputProps={{ maxLength: 12 }}
          variant="standard"
          value={dateUntil}
          onChange={(e) => {
            setDateUntil(e.target.value)
          }}
          type={'date'}
          fullWidth
        />
      </Box>
    </Box>
  )
}

export default OrderDateFilter
